import { getOrThrow } from 'quartz/globalState/api';
import { HISTORY_INSTANCE, HISTORY_BASE_PATH } from './globalState';

export const getHistory = () => getOrThrow(HISTORY_INSTANCE);

export const getHistoryBasePath = () => getOrThrow(HISTORY_BASE_PATH);
